import React from 'react';
import HeatConsumptionMessageDTO from 'features/consumption/dtos/HeatConsumptionMessageDTO';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';

type Props = {
  message: HeatConsumptionMessageDTO;
  className?: string;
}

const HeatConsumptionMessage = ({ message, className }: Props) => {
  // translations
  const tLables = useTranslation("consumption\\consumption").t;
  const tTypes = useTranslation("consumption\\enums\\heatConsumptionType").t;

  // helpers
  const getMessageText = () => { 
    let from = new Date(message.from!);

    let options = {
      period: `${format(from, "MM")}/${from.getFullYear()}`,
      heatConsumptionType: tTypes(message.heatConsumptionType!),
      reason: message.message
    }

    return tLables("heatConsumptionMessage.message", options);
  }

  // render
  return (
    <div className={className}>{getMessageText()}</div>
  );
}

export default HeatConsumptionMessage;